import { Box, useTheme , Button, TextField,Stack, MenuItem} from "@mui/material";
import Header from "../../../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import Typography from "@mui/material/Typography";
import { tokens } from "../../../../theme";
import { useDispatch, useSelector} from "react-redux";
import NiceDate from "../../../../components/global/NiceDate";
import ProfileAvatar from "../../../../components/user/ProfileAvatar";
import { useParams,useSearchParams } from "react-router-dom"

import { getSign , updateSign} from "../../../../slices/sign";
import { setMessage, clearMessage } from "../../../../slices/message"
import { useNavigate } from "react-router-dom";
import { Formik, useField, useFormikContext } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import UserService from "../../../../services/user.service";
import DisplayFormikState from "../../../../components/global/FormikHelper"

const DependentField = (props) => {
  const { values, touched, initialValues,setFieldValue } = useFormikContext() // get Formik state and helpers via React Context
  const [field, meta] = useField(props) // get the props/info necessary for a Formik <Field> (vs just an <input>)
  const dispatch = useDispatch();

  const  admin  = useSelector((state) => state.auth.user.collections?.find(collection => collection.id === values.collection));

  const [admins, setAdmins] = useState([]);

  async function fetchUsersForCollection(collection) {

    dispatch(clearMessage());

      let search = {"collection":collection, "includeParentCollections":true};
  
      try{
        const data = await UserService.getUsers(search) 
        setAdmins(data.list);

        if ((values.collection != initialValues.collection)){
          setFieldValue(props.name, admin?.administrator)
        }else{
          setFieldValue(props.name, initialValues.administrator)
        }


      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        
        dispatch(setMessage(message));
  
      }
  
  }

  React.useEffect(() => {

    fetchUsersForCollection(values.collection)

  }, [values.collection, touched.collection]) // make sure the component will update based on relevant changes

  return (
      <>
          <TextField {...props} {...field}>

            {admins?.map((option) => (
              <MenuItem key={option.username} value={option.username}>
                <Box display="flex" justifyContent="start" alignItems="baseline"> 
                  <Typography display="inline" >{`${option.firstName} ${option.lastName}`}</Typography> 
                  <Typography variant="title" color="inherit" noWrap>
                    &nbsp;
                  </Typography>
                  <Typography variant="small" display="inline">{`(${option.username})`}</Typography>
                </Box>
              </MenuItem>
            ))}

          </TextField>
          {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
      </>
  )
}

 
const AdminSignDetail = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const {id} = useParams()

  const [searchParams, setSearchParams] = useSearchParams()

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const  thisSign  = useSelector((state) => state.sign.data.list.find(sign => sign.id === id));  
  const avilableCollections = useSelector((state) => state.auth.user.collections);


  useEffect(() => {


    if(!thisSign){
      //need to get the collection to display 
      //see if its in the store
      dispatch(getSign({id}));
  
    };

}, [thisSign]);





  const getModifiedValues = (values, initialValues) => {
    let modifiedValues = {};
  
    if (values) {
      Object.entries(values).forEach((entry) => {
        let key = entry[0];
        let value = entry[1];
  
        if (value !== initialValues[key]) {
          modifiedValues[key] = value;
        }
      });
    }
  
    return modifiedValues;
  };
  

  const updateSchema = yup.object().shape({
    name: yup.string().required("required"),
    description: yup.string().required("required"),
    collection: yup.string().required("required"),
    administrator: yup.string().required("required"),
    signType: yup.string().required("required"),
  });
  
  const initialValues = {
    name: thisSign?.name ? thisSign.name : "",
    description: thisSign?.description ? thisSign.description : "", 
    collection: thisSign?.collection ? thisSign.collection : "",
    signType: thisSign?.signType ? thisSign.signType : "",
    administrator: thisSign?.administrator ? thisSign.administrator : "",
  };

  return (
    <>
    {thisSign &&

    <Box m="20px" >
        <Header title={thisSign.name} subtitle={thisSign.id}/>
    <Box>
    
    <Formik
        onSubmit={(values,actions) => {
        // this function should return the only modified values.
        const modifiedValues = getModifiedValues(values, initialValues); 

        const sign = {
          id: id,
          ...modifiedValues
        }
        dispatch(clearMessage());

        dispatch(updateSign({sign}))
        .unwrap()
        .then(() => {
          actions.setSubmitting(false)
        })
        .catch(() => {
          actions.setSubmitting(false)
        });

    }}
        validationSchema={updateSchema}
        initialValues={initialValues}
        enableReinitialize
      >
        {props => {
          const{
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          handleReset,
          isSubmitting,
          isValid,
          dirty,

          } = props;
          
        return (

          <form onSubmit={handleSubmit} >

            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                width: 600 ,
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >

              <TextField
                fullWidth
                variant="outlined"
                type="text"
                label="Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"

                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
                
              />
              <Box
                sx={{ gridColumn: "span 2" }}
              >
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h6" display="inline">Created:</Typography> 
                  <Typography display="inline"><NiceDate dateToFix = {thisSign.createdAt}/></Typography>
                </Box>
                
                <Box display="flex" justifyContent="space-between" >
                  <Typography variant="h6" display="inline">Last Modified:</Typography> 
                  <Typography display="inline"><NiceDate dateToFix = {thisSign.modifiedAt}/></Typography>
                </Box>

                <Box display="flex" justifyContent="space-between" >
                  <Typography variant="h6" display="inline">Last Seen:</Typography> 
                  <Typography display="inline"><NiceDate dateToFix = {thisSign.lastHeartBeat}/></Typography>
                </Box>
                
              </Box>

              <TextField
                fullWidth
                disabled

                variant="outlined"
                type="text"
                label="Sign Type"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.signType}
                name="signType"
                sx={{ gridColumn: "span 2" }}
                error={touched.signType && Boolean(errors.signType)}
                helperText={touched.signType && errors.signType}
              />
              
             
              

              <Box
                sx={{ gridColumn: "span 2" }}
              >
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h6" display="inline">Current Temp:</Typography> 
                  <Typography display="inline">{thisSign.currentTemp} C</Typography>
                </Box>
                
                <Box display="flex" justifyContent="space-between" >
                  <Typography variant="h6" display="inline">Current Humidity:</Typography> 
                  <Typography display="inline">{thisSign.currentHumidity} %</Typography>
                </Box>

                <Box display="flex" justifyContent="space-between" >
                  <Typography variant="h6" display="inline">Current Lirght:</Typography> 
                  <Typography display="inline">{thisSign.currentLight}</Typography>
                </Box>
                
              </Box>

              <TextField
                fullWidth
                select
                variant="outlined"
                type="text"
                label="Collection"
                onBlur={handleBlur}
    
                onChange={handleChange}

                value={values.collection}
                name="collection"
                sx={{ gridColumn: "span 2" }}
                error={touched.collection && Boolean(errors.collection)}
                helperText={touched.collection && errors.collection}
              >
                {avilableCollections.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <DependentField 
                fullWidth
                select
                variant="outlined"
                type="text"
                label="Administrator"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.administrator}
                name="administrator"

                error={touched.administrator && Boolean(errors.administrator)}
                helperText={touched.administrator && errors.administrator}
                sx={{ gridColumn: "span 2" }}
              >
                
                </DependentField>



              <TextField
                fullWidth
                variant="outlined"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                sx={{ gridColumn: "span 4" }}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description}
              />
              

              


              <Box display="flex" justifyContent="end" mt="20px" sx={{ gridColumn: "span 4" }}>
              <Stack direction="row" spacing={2}>

                <Button 
                  type="submit" 
                  color="secondary" 
                  variant="contained" 
                  disabled = {isSubmitting || !isValid || !dirty}
                >
                  Update Sign
                </Button>            
                
                
            </Stack>
              
            </Box>

            </Box>
              
            {/* <DisplayFormikState {...props} /> */}

          </form>

)}}
          </Formik>
    </Box>      
    </Box>
}
    </>
  );
};


export default AdminSignDetail;
